module.exports = __webpack_public_path__ + "img/notifi-error.54c599d1.svg";